import ProvsImg from '../../../../media/blogimgs/intelBlog.png';
import jotvsjit from '../../../../media/blogimgs/jotvsait.jpg';
import Dos from '../../../../media/blogimgs/Dos.jpg';
import maincon from '../../../../media/blogimgs/icmaincontrol.jpg';
const Blogs = [
    {
        id:"4",
        title: "اي سي المين كونترول",
        subtitle: "تسمع عن الشريحه ال بتتحكم في كل قطعه في جهاز الكمبيوتر ... لأ مش البروسيسور في المقال ده هكلمك عن المتحكم في البروسيسور اي سي التحكم الرئيسي او المين كونترول......",
        day:"الأحد",
        date: "٢٣/٢/٢٠٢٥",
        time:"١١:٥٨ ص",
        img: maincon,
        des: 
        <p>
            أي سي المين كنترول

            هو ال اي سي المتحكم بضبط فولتية التيار اللازم لتشغيل البروسيسور<br/>
            تتكون دائرة البروسيسور باللوحه الأم من مقبس 12 فولت و عدة قنوات لتوفير الفولت المناسب لتشغيل البروسيسور<br/>
            وتتكون كل قناة من: 
            <ul>
                <li>
                    موسفت علوي رئيسي 
                </li>
                <li>
                    عدة موسفتات سفليه فرعيه 
                </li>
                <li>
                    عدة مكثفات لتنعيم التيار 
                </li>
                <li>
                    ملف واحد لكل قناه
                </li>
            </ul>
            و لذلك كي نحدد عدد قنوات دائرة البروسيسور نقوم بحصر عدد الملفات القريبه من الدائره و هذه الملفات يكون عليها الفولت اللازم لتشغيل البروسيسور المعروف ب ال Vcore<br/>
            و يبدأ تشغيل البروسيسور بتغذية المقبس ب ال 12 فولت من السلك الأصفر من مزود الطاقه الموصل باللوحه <br/> يتم تمرير التيار 12 فولت علي مصب الموسفت العلوي و الذي يعمل كسويتش يقوم بالتحكم فيه اي سي المين كنترول وهو موضوع اليوم <br/>فهذا ال أي سي كي يعمل يحتاج الي وصول تيار التشغيل وهو 5 فولت في الغالب في الصوره الموضحه مخطط تشريحي ل أي سي المين كنترول يكون علي البين رقم (10) <br/>فولت التشغيل و كذلك يحتاج لفولت اخر هام للغايه و هو vtt و هو الفولت المولد من البروسيسور و الذي من خلاله يتم تحديد نوع البروسيسور و الفولت اللازم لتشغيله و يقوم ال أي سي بتوليد نبضه علي بوابة الموسفت الرئيسي من خلال البينات الموضحه علي المخطط وهي Lgate , Ugate, Boot حيث U تدل علي الموسفت العلوي و L علي الموسفت السفلي و Boot مشتركه بين الإثنين و الرقم الموجود بعدها يدل علي رقم القناه الموجه لها النبضه لتمرير التيار اللازم لتشغيل البروسيسور<br/> الذي بدوره يمرعلي الموسفتات الفرعيه و التي تعمل علي التأكد من ان التيار المار هو التيار المناسب لتشغيل البروسيسور و من ثم يخرج التيار من مصدر الموسفت الفرعي الأخير ثم يتوجه للمكثفات لتنعيم التيار و من ثم للملف الذي يكون عليه التيار اللازم لتشغيل البروسيسور و بعدها يمر التيار للبروسيسور و من ثم يقوم بعمل مهامه<br/> و عند التأكد من ان الدائره تعمل بشكل جيد يصدر أي سي المين كنترول نبضة تدل علي ان الدائرة تعمل بنجاح و تكون علي PGOOD علي البين رقم (37)
            <center><h2 className='mt-4'><strong><u>#SASKE_Company</u> 😎 ... <u>بوابتك للخدمات التقنيه</u>👌</strong></h2></center>
        </p>
        ,
    },
    {
        id:"3",
        title: "هجوم دوس",
        subtitle: "ما هو هجوم دوس وكيف يحدث و كيف نحمي أنفسنا منه ؟",
        day:"الأحد",
        date: "٢٣/٢/٢٠٢٥",
        time:"١١:٤٨ ص",
        img: Dos,
        des: 
        <p>
            هجوم حجب الخدمه هو هجوم علي الشبكات يمنع المستخدمين من الوصول لخادم الشبكه <br/>
            لأن هذا الهجوم يعتمد علي عمل الكثير من الطلبات من الخادم و الذي بدوره يؤدي لإستهلاك كل موارد الخادم مما يؤدي إلي تعطيله و عدم القدره للوصول إليه<br/>.
            يعني نقدر نقول ان الخادم عباره عن جهاز كمبيوتر ضخم عنده ذاكره تخزينيه كبيره و مواصفات خاصه عشان يقدر يقدم خدماته ال بتخلي المستخدمين قادرين علي تصفح المواقع او البيانات ال بيقدمها الخادم بشكل يومي 24 ساعه دون إنقطاع و بأفضل جوده ممكنه <br/>لكن لو حصل أي حاجه أستهلكت كل موارد الخادم ده هيؤدي لتعطل الخادم عن العمل و عدم قدرته علي تقديم خدماته لأن برامج الخادم ستتوقف بشكل مؤقت (تتجمد) و المستخدمين مش هيقدرو يوصلو للخادم ولا إستخدام خدماته<br/>
            في نوع تاني من هجوم حجب الخدمه و هو 
            <br/>
            هجوم حجب الخدمه الموزع و ده المنتشر اكتر و هو بيكون نفس الفكره بالظبط و لكن بإستخدام أكتر من جهاز او خادم لمهاجمة الخادم الضحيه
            أنواع هجوم حجب الخدمه:
            <br/>
            هجوم حجب الخدمه هو فئه أكثر من كونه نوع و هنا قائمه غير شامله بأنواع هجوم حجب الخدمه
            <ul>
            <li>
                    bandwidth attack
                </li>
                <li>
                    service request flood
                </li>
                <li>
                    SYN flooding attack
                </li>
                <li>
                    ICMP flood attack
                </li>
                <li>
                    peer-to-peer attack
                </li>
                <li>
                    permanent DoS attack
                </li>
                <li>
                    application level flood attack
                </li>
            </ul>
            <center><h2 className='mt-4'><strong><u>#SASKE_Company</u> 😎 ... <u>بوابتك للخدمات التقنيه</u>👌</strong></h2></center>
        </p>
        ,
    },
    {
        id:"2",
        title: "كيف يتم إعداد التطبيقات و تشغيلها في Flutter",
        subtitle: "هل أنت مستعد لرحله داخل عملية تشغيل تطبيقات Flutter......",
        des: 
        <p>
            في نظام Flutter، تتوفر طريقتين لإعداد التطبيقات وتشغيلها: AOT و JIT.
            AOT هو اختصار لـ "أحصل على الوقت مسبقًا" (Ahead Of Time Compilation)، وهو عندما يتم تجميع التطبيق إلى شيفرة ثنائية تبدأ فور تشغيلها. يسمح إعداد AOT لتطبيقات Flutter بأداء أسرع وفترة تشغيل أقل. من المفترض أنه يوفر ميزات أفضل في المستخدم النهائي. يتم تجميع التطبيقات بواسطة Dart VM إلى شيفرة جهازية قبل عملية النشر، مما يزيد من حجم التطبيق ولكنه يحسن زمن التشغيل.
            JIT هو اختصار لـ "في الوقت المناسب" (Just In Time Compilation). في JIT، يتم تجميع الشفرة المصدرية تدريجيًا وتحويلها إلى شيفرة ثنائية خلال تشغيل التطبيق. يتيح ذلك التحسينات الديناميكية وتحسين الأداء عند الضرورة. تناسب تقنية JIT بشكل مثالي خلال مرحلة تطوير التطبيق، حيث يتيح إعادة التحميل الساخن(Hot Reload) (عملية إعادة تحميل التعديلات التي تم إجراؤها على الشيفرة المصدرية دون إعادة تشغيل التطبيق).
            في المجمل، تستخدم طرق AOT و JIT معًا في عملية تطوير Flutter. عند تشغيل التطبيقات في وضع الإنتاج، يتم استخدام AOT لتوفير أداء افضل، بينما تستخدم JIT في وضع تطوير التطبيق لتسهيل الجدولة الزمنية وتحسين سير العمل للمطور.
            طب يعني اي تجميع التطبيق الي شفره ثنائيه دا اللي هنعرفه في البوست اللي جاي؟
            <center><h2 className='mt-4'><strong><u>#SASKE_EG</u> 😎 ... <u>بوابتك للخدمات التقنيه</u>👌</strong></h2></center>
        </p>
        , 
        time:"10:00pm",
        date: "٢٢/١/٢٠٢٥",
        day:"الأحد",
        img: jotvsjit,
    },
    {
        id:"1",
        title: "من الأفضل Intel ام AMD",
        day:"الأحد",
        date: "٢٢/١/٢٠٢٥",
        time:"10:00pm",
        subtitle: "هنتطرق لأهم التفاصيل عن المعالجات و أي معالج هو المناسب لإستخدامك......",
        img: ProvsImg,
        des: 
        <p>
            بتحتار كتير لما تيجي تشتري #لابتوب او جهاز #pc اي المناسب و إزاي تختار الأفضل وفق إحتياجاتك او البادجت بتاعتك
            النهارده هنركز علي توضيح النقطه دي بالتفصيل
            البوست ده هيوضحلنا كل ما يتعلق بالبروسيسور او #المعالج و إزاي نختاره و هنبدأ بيه السلسله دي من البوستات لأنه من أهم القطع �
            طيب صلي بينا علي النبي كده و ركز معانا كويس اووووي
            أول حاجه محتاجين نكون علي علم بيها هو أي ال بيفرق بين كل #معالج و التاني و ليه في إختلاف و الاجابه علي السؤال ده محتاجه كتب عزيزي العميل مش بس بوست و لكن بأختصار بيختلف كل معالج عن غيره في السوق من حيث طريقة التصنيع و الميزات ال بينفرد بيها كل معالج عن غيره و السبب في الاختلاف ده هو إختلاف الشركات المصنعه و غرض استخدام المعالج و دوره الأساسي و هنا في حرب بين أكبر شركتين لتصنيع المعالجات و هم #Intel و #Amd ال بينهم تنافس شديد و شرس ناهيك عن بحر الإصدارات و الموديلات و الأنواع التي تصنعها كلاً من الشركتين
            و أول إختلاف بينهم هو السعر :
            معالجات Amd من فئة #Ryzen هي أفضل المعالجات علي الإطلاق حيث أن أقوي معالجات هذه الفئه يأتي بسعر أقل من نظيره Intel بنفس المواصفات
            علي سبيل المثال:
            Amd Ryzen 7 1800X سعره ما يقارب ال 500$ في نفس الوقت Core I7 6900K من Intel و المكافئ له في المواصفات بسعر 1000$ و بكده البورد الداعمه لـ Amd أقل سعراً من الداعمه لـ Intel
            و في رأيي الشخصي يرجع السبب لشهرة الشركه و سمعتها في السوق
            تاني إختلاف نركز عليه في البوست هي #سرعة المعالج في عملية معالجة و نقل البيانات و أيضاً نقطه أخري لصالح Amd حيث أن أخر التقارير أوضحت أن Amd تتفوق علي نظيرتها Intel
            عارف اني بضرب في معلومات أشبه بالثوابت الكونيه لدي عملائنا و لكن كل كلمه تم ذكرها في هذا البوست لها مصادرها و مذكوره في اول تعليق
            و بكده Amd أسرع و أرخص
            تحس ان Intel مثال حي علي مبدأ الصيت ولا الغنى عزيزي العميل.
            طيب و بالنسبه للألعاب و تشغيلها
            كذلك الأمر لصالح Amd من خلال معالجات الفئه المتوسطه Ryzen 5000
            اما اسرع معالج تشغيل #ألعاب في السوق حالياً هو Ryzen 9 5900X ونظيره الأرخص Ryzen 5 5600X بسعر 300$ فبينافسه من Intel المعالج #Core I9 11900K و الفئه الأقل Core I7 1170K ولا تنسي أن Amd تتميز بوجود #كارت #شاشه بمواصفات مقبوله من Amd.
            ووقفة إنصاف احنا من مرشحي معالجات Amd و بقوه لكل عملائنا علي عكس المتوقع تماماً و بنرشح في حالة تشغيل الألعاب بكفائه عاليه Amd Ryzen 9 5900X
            مع العلم ان تتفوق Intel في العاب الـ #stream حيث انها ألعاب بتحتاج قوة النواه الواحده و ده الـ بتوفره Intel و شاطره فيه علي عكس Amd
            و بالنسبه لتشغيل #البرامج #الهندسيه ال بتحتاج تعدد عمليات المعالجه
            فكذلك تذهب لصالح Amd حيث تمتلك أقوي المعالجات ذو الـ16 #نواه و هو Ryzen 9 5950 الذي يتفوق بدوره علي نظيره من Intel Core I9 11900K
            اما بالنسبه للإستهلاك و الحراره
            أعتقد أنك أصبحت تعلم يا عزيزي تصدر Amd طاقه حراريه أقل من Intel في نفس الوقت الـ بتستهلك فيه قدر أقل من الطاقه و بكفائه أعلي ايضاً و يعود السبب لتقنيات TSMC 7nm node التي تتميز بها معالجات Amd
            و يمكن إعتبار معالج Ryzen 5000 أفضل الشرائح من حيث إستهلاك الطاقه علي الإطلاق.
            و بالنسبه للأمان: أيضاً تتميز Amd بدرجه أعلي من #الأمان حيث ان Intel أكثر إنتشاراً و يتم تصميم #البرمجيات #الخبيثه التي تعمل عليها لشيوعتها لدي المستخدمين علي عكس Amd التي يقل إستخدامه و بالتالي يقل إستهدافها من قبل #القراصنه و #الهاكرز.

            بالنسبه لإختلاف #الجيل يكون الجيل أفضل كلما تقدمنا حيث ان الجيل يكون رقم تعبيري عن سنة الإصدار و كلما كان المعالج أحدث كان مبني بـ #معمارية أفضل و جاهز لمعالجة #بيانات أكبر و بشكل #أسرع و لكن مع ذلك تزداد درجات الحراره الصادره من المعالج أثناء عملية التشغيل و لذلك تحتاج أغلب الأجهزه الحديثه لأنظمة تبريد عاليه جداً مثل #التبريد_المائي الفوري حيث ان درجات حرارة تلك المعالجات عاليه جداً و يتم إستخدامها في عمليات و حسابات #هندسيه غايه في التعقيد

            نتمني أن نكون قدمنا #معلومات قيمه تفيدكم تساعدكم في تحديد المعالج المناسب حسب إحتياجاتكم عملائنا الأعزاء
            ولو لسه محتار ازاي تجيب جهاز pc او لابتوب
            هنا بيجي دورنا كشركة #SASKE للبرمجيات و خدمات الكمبيوتر حيث أنه من واجبنا توفيق طلب حضراتكم بالمواصفات الـ تتناسب مع إحتياجات حضراتكم او البادجيت
            متترددش في التواصل معانا لمساعدتك في إختيار الأنسب☑️☑️☑️

            يمكنكم التواصل معنا علي الأرقام التاليه 🙋🏻:
            فون و واتساب 01060950140📞
            تليفون الشركه ☎0862375871

            كما و تسعدنا زيارتكم لنا خلال مواعيد العمل الجديده:
            يومياً من الساعه ١٢ظهراً حتي ١٠م
            عدا الجمعه من الساعه ٣:٣٠ عصراً حتي ١٠م
            علي العنوان التالي :
            9 شارع الحريه-كورنيش النيل-برج المدينه أعلي ايس كريم ابو سيد و امام مسجد الفولي
            <br />
            <center><h2 className='mt-4'><strong><u>#SASKE_EG</u> 😎 ... <u>بوابتك للخدمات التقنيه</u>👌</strong></h2></center>
        </p>, 
    },
]

export default Blogs;

/*
{
    id:"",
    title: "",
    subtitle: "",
    day:"",
    date: "",
    time:"",
    img: ,
    des: 

    <center><h2 className='mt-4'><strong><u>#SASKE_Company</u> 😎 ... <u>بوابتك للخدمات التقنيه</u>👌</strong></h2></center>
    ,
},
*/